import { TablePagination } from '@mui/material';
import { captureMessage } from '@sentry/react';
import { PaginationContainer } from 'Components/TableBase/Pagination';
import { StyledTable, StyledTableBody } from 'Components/TableBase/Table';
import { IBaseChain, IChainWithDepth } from 'FeatureModules/ComponentChain/types/chain.types';
import React, { FC, useState } from 'react';
import { COMPONENTS_TABLE_ROWS_PER_PAGE } from 'utils/pagination.utils';
import TableRow, { ITableRowAction } from '../../../ComponentChain/Components/Table/TableRow';
import { ECOMPONENT_CHAIN_COLUMN_IDS } from '../../../ComponentChain/utils/headerColumns';

interface IProductSupplyChainTableProps {
  productSupplyChains: (IBaseChain | IChainWithDepth)[];
  actions: ITableRowAction[];
  onRowClick?: (productId: string, chainId: string) => void;
}

const ProductSupplyChainTable: FC<IProductSupplyChainTableProps> = ({
  productSupplyChains,
  onRowClick,
  actions,
}) => {
  const [currentPage, setCurrentPage] = useState<number>(0);

  return (
    <StyledTable>
      <StyledTableBody>
        {productSupplyChains
          .slice(
            currentPage * COMPONENTS_TABLE_ROWS_PER_PAGE,
            currentPage * COMPONENTS_TABLE_ROWS_PER_PAGE + COMPONENTS_TABLE_ROWS_PER_PAGE
          )
          .map(item => {
            const { id, chainTasksDetails, title, image, productId } =
              'chain' in item ? item.chain : item;
            return (
              <TableRow
                id={id}
                key={id}
                columnKeys={[
                  ECOMPONENT_CHAIN_COLUMN_IDS.TITLE,
                  ECOMPONENT_CHAIN_COLUMN_IDS.ACTIONS,
                ]}
                isIndirectChain={'depth' in item ? item.depth > 1 : undefined}
                title={title}
                taskDetails={chainTasksDetails}
                image={image}
                isSupplyChain={'depth' in item ? item.depth > 0 : undefined}
                actions={actions}
                onRowClick={() =>
                  productId
                    ? onRowClick?.(productId, id)
                    : captureMessage('Supply chain has no product Id', { level: 'error' })
                }
              />
            );
          })}
      </StyledTableBody>
      {productSupplyChains.length > COMPONENTS_TABLE_ROWS_PER_PAGE && (
        <PaginationContainer>
          <TablePagination
            component="div"
            rowsPerPageOptions={[]}
            count={productSupplyChains.length}
            rowsPerPage={COMPONENTS_TABLE_ROWS_PER_PAGE}
            page={currentPage}
            onPageChange={(_, newPage) => setCurrentPage(newPage)}
            labelDisplayedRows={({ page }) =>
              `Page ${page + 1} of ${Math.ceil(
                productSupplyChains.length / COMPONENTS_TABLE_ROWS_PER_PAGE
              )}`
            }
          />
        </PaginationContainer>
      )}
    </StyledTable>
  );
};

export default ProductSupplyChainTable;
